import * as React from "react"

type Props = {
    size: 'sm' | 'md' | 'lg'
    className?: string
}

const HandicaddieLogo = ({size, className}: Props) => {

    let width: number;
    let height: number;

    switch (size) {
        case "sm":
            width = 70
            height = 35
            break;
        case "md":
            width = 100
            height = 50
            break;
        case 'lg':
            width = 200
            height = 100
            break;
    }

    return <svg viewBox="0 0 136 68" width={width} height={height} className={className}>
        <g>
        <path
            id="handi_h"
            style={{ fill: 'var(--text)' }}
            d="M3.67.616h5.857v11.407c2.246-1.938 4.4-2.995 6.914-2.995 4.4 0 8.016 2.862 8.016 8.544V33.03h-5.859V21.976c0-4.756-.573-7.575-4.008-7.575a4.637 4.637 0 0 0-3.964 2.29c-1.189 1.85-1.1 3.964-1.1 6.386v9.953H3.669Z"
        />
        <path
            id="handi_a"
            style={{ fill: 'var(--text)' }}
            d="M44.936 30.564a9.722 9.722 0 0 1-7.222 3.083c-5.946 0-11.142-5.109-11.142-12.287 0-7.311 4.933-12.331 11.01-12.331a10.043 10.043 0 0 1 7.355 3.171V9.646h5.857v23.386h-5.857Zm-12.463-9.249c0 4.008 2.642 6.959 6.3 6.959 3.611 0 6.43-2.731 6.43-7 0-4.1-2.731-6.87-6.43-6.87-3.878-.003-6.3 3.08-6.3 6.911Z"
        />
        <path
            id="handi_n"
            style={{ fill: 'var(--text)' }}
            d="M60.129 12.023c2.246-1.894 4.316-2.995 6.914-2.995a7.7 7.7 0 0 1 8.015 8.015V33.03h-5.857V21.976c0-4.624-.4-7.575-3.964-7.575a4.593 4.593 0 0 0-3.964 2.246c-1.189 1.894-1.145 4.008-1.145 6.43v9.953h-5.857V9.644h5.857Z"
        />
        <path
            id="handi_d"
            style={{ fill: 'var(--text)' }}
            d="M95.582 30.564a9.722 9.722 0 0 1-7.222 3.083c-5.945 0-11.142-5.109-11.142-12.287 0-7.311 4.933-12.331 11.01-12.331a10.044 10.044 0 0 1 7.355 3.171V.616h5.857V33.03h-5.857Zm-12.463-9.249c0 4.008 2.642 6.959 6.3 6.959 3.611 0 6.43-2.731 6.43-7 0-4.1-2.731-6.87-6.43-6.87-3.878-.003-6.3 3.08-6.3 6.911Z"
        />
        <path
            id="handi_i"
            style={{ fill: 'var(--text)' }}
            d="M110.997 3.872a3.74 3.74 0 0 1-3.743 3.743 3.9 3.9 0 0 1-3.743-4.052 3.649 3.649 0 0 1 3.743-3.567 3.8 3.8 0 0 1 3.743 3.876Zm-6.65 5.769h5.857v23.386h-5.857Z"
        />
        <path
            id="caddie_c"
            style={{ fill: 'var(--text)' }}
            d="M23.738 63.262c-2.511 3.259-6.034 4.889-10.614 4.889C5.153 68.151 0 62.734 0 55.908c0-7 5.461-12.375 13.212-12.375a12.6 12.6 0 0 1 10.79 5.329l-4.889 2.687a7.363 7.363 0 0 0-5.857-2.642c-4.492 0-7.355 3.039-7.355 7.091 0 3.964 2.774 6.782 7.09 6.782a7.436 7.436 0 0 0 6.122-2.687Z"
        />
        <path
            id="caddie_a"
            style={{ fill: 'var(--text)' }}
            d="M43.452 65.068a9.721 9.721 0 0 1-7.223 3.083c-5.945 0-11.142-5.109-11.142-12.287 0-7.311 4.932-12.331 11.01-12.331a10.045 10.045 0 0 1 7.355 3.171v-2.555h5.857v23.386h-5.857ZM30.988 55.82c0 4.008 2.642 6.958 6.3 6.958 3.611 0 6.43-2.731 6.43-7 0-4.1-2.731-6.871-6.43-6.871-3.878-.002-6.3 3.081-6.3 6.913Z"
        />
        <path
            id="caddie_d"
            style={{ fill: 'var(--text)' }}
            d="M69.376 65.068a9.721 9.721 0 0 1-7.223 3.083c-5.945 0-11.142-5.109-11.142-12.288 0-7.31 4.932-12.331 11.01-12.331a10.045 10.045 0 0 1 7.355 3.171V35.12h5.857v32.414h-5.857Zm-12.464-9.249c0 4.008 2.642 6.958 6.3 6.958 3.611 0 6.43-2.73 6.43-7 0-4.1-2.731-6.871-6.43-6.871-3.877-.001-6.3 3.082-6.3 6.913Z"
        />
        <path
            id="caddie_d"
            style={{ fill: 'var(--text)' }}
            d="M95.579 65.068a9.721 9.721 0 0 1-7.223 3.083c-5.945 0-11.142-5.109-11.142-12.288 0-7.31 4.932-12.331 11.01-12.331a10.044 10.044 0 0 1 7.355 3.171V35.12h5.858v32.414h-5.858Zm-12.463-9.249c0 4.008 2.642 6.958 6.3 6.958 3.611 0 6.43-2.73 6.43-7 0-4.1-2.731-6.871-6.43-6.871-3.878-.001-6.3 3.082-6.3 6.913Z"
        />
        <path
            id="caddie_i"
            style={{ fill: 'var(--text)' }}
            d="M111.026 38.376a3.74 3.74 0 0 1-3.743 3.743 3.9 3.9 0 0 1-3.744-4.052 3.649 3.649 0 0 1 3.744-3.567 3.8 3.8 0 0 1 3.743 3.876Zm-6.65 5.769h5.857v23.386h-5.857Z"
        />
        <path
            id="caddie_e"
            style={{ fill: 'var(--text)' }}
            d="M134.967 62.998c-2.51 3.567-5.813 5.153-10.746 5.153-7.443 0-12.243-5.461-12.243-12.332 0-6.386 4.624-12.287 12.155-12.287 7.4 0 12.419 5.285 12.419 12.684 0 .529-.044.793-.044 1.321h-18.849a6.258 6.258 0 0 0 6.562 5.417 7.57 7.57 0 0 0 5.813-2.29Zm-4.316-10.085c-.793-2.731-3.3-4.4-6.43-4.4a6.383 6.383 0 0 0-6.3 4.4Z"
        />
        </g>
    </svg>
}

export default HandicaddieLogo;
